import { css } from 'styled-components';

import ExtraBold_woff2 from './Vazirmatn-VariableFont_wght.ttf';
import ExtraBold_woff from './Vazirmatn-VariableFont_wght.ttf';

import Bold_woff2 from './Vazirmatn-VariableFont_wght.ttf';
import Bold_woff from './Vazirmatn-VariableFont_wght.ttf';

import Medium_woff from './Vazirmatn-VariableFont_wght.ttf';
import Medium_woff2 from './Vazirmatn-VariableFont_wght.ttf';

import Regular_woff from './Vazirmatn-VariableFont_wght.ttf';
import Regular_woff2 from './Vazirmatn-VariableFont_wght.ttf';

import SemiBold_woff from './Vazirmatn-VariableFont_wght.ttf';
import SemiBold_woff2 from './Vazirmatn-VariableFont_wght.ttf';

export const fonts = css`
  @font-face {
    font-family: 'ExtraBold';
    src: url(${ExtraBold_woff});
    src: url(${ExtraBold_woff2}) format('woff2'),
      url(${ExtraBold_woff}) format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'SemiBold';
    src: url(${SemiBold_woff});
    src: url(${SemiBold_woff2}) format('woff2'),
      url(${SemiBold_woff}) format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Bold';
    src: url(${Bold_woff});
    src: url(${Bold_woff2}) format('woff2'), url(${Bold_woff}) format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Regular';
    src: url(${Regular_woff});
    src: url(${Regular_woff2}) format('woff2'),
      url(${Regular_woff}) format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Medium';
    src: url(${Medium_woff});
    src: url(${Medium_woff2}) format('woff2'),
      url(${Medium_woff}) format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
`;
